import { Container, Row, Col } from "react-bootstrap"
import { useTranslation } from 'react-i18next'
import PropertyCard from "./PropertyCard"

const SoldOut = ({ offers }) => {
  const [t] = useTranslation()
  const soldOutOffers = offers.filter(offer => offer.shares_left === 0)
  return (
    <Container>
      <div className='title fz-34 mt-5 mb-3'>
        {t`Dự án đã đóng đầu tư`}
      </div>
      <Row>
        {Array.isArray(soldOutOffers) && soldOutOffers.map(offer => (
          <Col
            xs={12}
            md={6}
            lg={4}
            key={offer.id}
            className='mb-3'
            style={{ padding: 0 }}
          >
            <PropertyCard
              {...offer}
            />
          </Col>
        ))}
      </Row>
    </Container>
  )
}

export default SoldOut
